module.exports = "pegasus_template/assets/blocks/header-6-theme4.png";